import { useState } from "react";
import { useDispatch } from "react-redux";
import { useGoogleLogin } from "@react-oauth/google";
import axios from "../axios-config";
import { loginAuth } from "../redux/actions/auth";
import { maybeSyncWorkspaceOnce } from "../redux/actions/billing";
import { showToast } from "../helper/ShowToast";

export const useGoogleAuth = ({ navigate, successMessage }) => {
  const [googleLoading, setGoogleLoading] = useState(false);
  const dispatch = useDispatch()

  const googleLogin = useGoogleLogin({
    flow: "auth-code",
    onSuccess: async (codeResponse) => {
      try {
        setGoogleLoading(true);
        // send code to backend
        const res = await axios.post("/user/v1/google-login", {
          code: codeResponse.code,
        });

        const { token, isProfileComplete, user, access } = res.data.data;

        showToast('success', successMessage || "Google login successful!")

        if (!isProfileComplete) {
          navigate("/complete-registration", {
            state: {
              email: user.email,
              firstName: user.firstName || "",
              lastName: user.lastName || "",
              userName: user.userName || "",
              country: user.country || null,
              from: "google",
            },
          });
          return;
        } else {
          localStorage.setItem("authToken", token);
          const userData = {
            token,
            assignedArtistSongstateId: user?.assignedArtistSongstateId,
            access: access || null,
          };
          dispatch(loginAuth(token, user, access || null));
          // TODO(legacy-migration): Phase 2 — remove maybeSyncWorkspaceOnce after backend login sync is removed.
          dispatch(maybeSyncWorkspaceOnce());
          navigate('/dashboard', { state: userData, replace: true });
        }
      } catch (err) {
        const apiError = err?.response?.data;
        if (apiError?.code === "ACCOUNT_EXISTS_DIFFERENT_PROVIDER") {
          showToast('error', apiError.message)
        } else {
          showToast('error', apiError?.message || "Google login failed")
        }
      } finally {
        setGoogleLoading(false);
      }
    },

    onError: () => {
      showToast('error',"Google login failed")
    },
  });

  const openGooglePopup = () => {
    googleLogin(); // ✅ opens popup
  };

  return { openGooglePopup, googleLoading };
};
